import React, { useEffect, useState } from 'react';
import 'src/style/vehicletrackingqualitycheck.css';
import 'src/style/targetvsactual.css';
import { useDispatch, useSelector } from 'react-redux';
import { getQualityCheckVehicleTrackingList } from 'src/redux/Actions/VehicleTracking';
import { useParams } from 'react-router-dom';
import { Drawer } from '@mui/material';
import CreateQcProductDrawer from 'src/components/VehicleTrackingDetails/QualityCheck/QualityCheckDrawers/CreateQcProductDrawer';
import CreateQcLogDrawer from 'src/components/VehicleTrackingDetails/QualityCheck/QualityCheckDrawers/CreateQcLogDrawer';
import QualityCheckLogs from 'src/components/VehicleTrackingDetails/QualityCheck/QualityCheckLogs';

function QualityCheckTabContent() {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.AuthReducer);
  const tenantOrganisationId = authReducer.userData.organisations?.id;
  const themeColor = authReducer.userData.tenant?.theme;
  const { vehicleTrackingNumber } = useParams();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerStep, setDrawerStep] = useState('step1');
  const [selectedQualityCheckId, setSelectedQualityCheckId] = useState(null);

  const [formData, setFormData] = useState({
    vehicle_tracking_number: vehicleTrackingNumber,
    statusKey: '3',
    vehicle_tracking_line_items: [],
    dimensions: [],
  });

  const vehicleTrackingReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const { availableQualityChecksForVehicleTracking, vehicleTrackingDetails } =
    vehicleTrackingReducer;

  const shouldShowCreateLogButton =
    !vehicleTrackingDetails?.requestedStage?.completed &&
    vehicleTrackingDetails?.requestedStage?.entry_log_exist;

  const handleQualityCheckSelection = (qualityCheckId) => {
    setSelectedQualityCheckId((prevId) =>
      prevId === qualityCheckId ? null : qualityCheckId,
    );
  };

  useEffect(() => {
    dispatch(
      getQualityCheckVehicleTrackingList(
        tenantOrganisationId,
        vehicleTrackingNumber,
      ),
    );
  }, [dispatch, tenantOrganisationId, vehicleTrackingNumber]);

  return (
    <>
      <div className="div-flex-column rg-5 section-title">
        <div className="div-flex-row div-space-between div-align-center">
          <div className="text-sm text-grey">
            Select the checkbox to create a test to verify product quality.
          </div>
          {shouldShowCreateLogButton && (
            <div className="div-flex-row">
              <button
                className={`${
                  selectedQualityCheckId
                    ? `create-quality-check-log theme-background-${themeColor}`
                    : 'create-quality-check-log-disable'
                } div-align-center`}
                disabled={!selectedQualityCheckId}
                onClick={() => setDrawerOpen(true)}
              >
                <span className="text-sm">Create Log</span>
              </button>
            </div>
          )}
        </div>
      </div>

      <div>
        <div className="div-flex-column rg-10">
          {availableQualityChecksForVehicleTracking?.map((qualityCheck) => (
            <QualityCheckLogs
              key={qualityCheck.quality_check_id}
              qualityCheck={qualityCheck}
              isSelected={
                selectedQualityCheckId === qualityCheck.quality_check_id
              }
              onSelectionChange={handleQualityCheckSelection}
            />
          ))}
        </div>
      </div>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
          setDrawerStep('step1');
        }}
        ModalProps={{ keepMounted: false }}
        sx={{ zIndex: 1 }}
        PaperProps={{
          sx: { width: '50%' },
        }}
      >
        {drawerStep === 'step1' && (
          <CreateQcProductDrawer
            setDrawerOpen={setDrawerOpen}
            setDrawerStep={setDrawerStep}
            vehicleTrackingNumber={vehicleTrackingNumber}
            qualityCheckId={selectedQualityCheckId}
            formData={formData}
            setFormData={setFormData}
          />
        )}

        {drawerStep === 'step2' && (
          <CreateQcLogDrawer
            setDrawerStep={setDrawerStep}
            formData={formData}
            setFormData={setFormData}
            vehicleTrackingNumber={vehicleTrackingNumber}
            qualityCheckId={selectedQualityCheckId}
          />
        )}
      </Drawer>
    </>
  );
}

export default QualityCheckTabContent;
